<div class="pagination-container">
  <div class="pagination-content">
    <pagination-infinite-scroll (scrolled)="loadNew.emit()">
      <div class="px-3 pt-1" [ngClass]="scrollContentClass">
        <div *ngFor="let item of list; let last = last">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, lastShown: last }"></ng-container>
        </div>
      </div>
    </pagination-infinite-scroll>
  </div>
</div>
